import React from 'react';
import PersonnelDocuments from '@/components/PersonnelDocuments';
import { hasCap } from '@/lib/capabilities';
import { useEffectiveMe } from '@/lib/effectiveMe';

export default function DocumentsTab({ legacyId }) {
  const me = useEffectiveMe();
  const legacyManage = hasCap(me, 'personale.documents.manage');
  const hasDocumentCapability = (code) => hasCap(me, code) || hasCap(me, 'personale.documents.*');
  return <PersonnelDocuments mode="profile" legacyId={legacyId} onManagePermission={legacyManage} capabilities={{
    canRead: hasDocumentCapability('personale.documents.read') || hasCap(me, 'personale.view') || legacyManage,
    canCompanyUpload: hasDocumentCapability('personale.documents.company.upload') || legacyManage,
    canReplace: hasDocumentCapability('personale.documents.replace') || legacyManage,
    canDelete: hasDocumentCapability('personale.documents.delete') || legacyManage,
    canSensitive: hasCap(me, 'personale.documents.sensitive.read'),
    canManagePolicy: hasDocumentCapability('personale.documents.policy.manage'),
  }} />;
}
